function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#a62731",
  d: "M27.02 7.507H4.981a2.131 2.131 0 00-2.128 2.129v13.835c0 1.189.97 2.129 2.128 2.129H27.02a2.131 2.131 0 002.128-2.129V9.637a2.131 2.131 0 00-2.128-2.13zm-.41 1.253l-9.201 9.203a1.986 1.986 0 01-2.818 0L5.388 8.76H26.61zM4.136 23.629c0-.063-.032-.094-.032-.157V9.637c0-.125.032-.22.062-.345l.031.031 7.106 7.106-7.167 7.2zm1.033.719l7.043-7.043 1.534 1.535a3.2 3.2 0 002.285.939 3.2 3.2 0 002.286-.939l1.439-1.44 6.951 6.948H5.169zm22.727-.876a.897.897 0 01-.063.282l-7.229-7.231 7.198-7.2.031-.031c.032.094.063.22.063.345v13.835z"
});

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgMail;